import { useEffect, useState } from "react";
import * as S from "./FilmeMataramZacariasStyled";
import LoadingOverlay from "../../../../../components/LoadingComponente/Loading";

const FilmeMataramZacarias: React.FC = () => {
  const [onLoading, setOnLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOnLoading(false);
      
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <S.MainContainer>
      {onLoading && <LoadingOverlay />}

      <S.Body>
        <S.ContainerSubA>
          <S.ContainerRightA>
            <S.TitleA>Mataram Zacarias</S.TitleA>
            <S.TextoAContiner>
              <S.TextoA>
                Mataram João Zacaria é uma tragédia rural. Será um filme de
                setenta minutos, ambientado no interior do Paraná, na metade do
                século XX. A história se desenvolve em torno de uma grande
                fazenda numa comunidade rural. É uma livre interpretação do
                episódio bíblico da morte de João Batista, transposto para o
                universo rural do Brasil no século passado. Diálogos, direção de
                arte e fotografia visarão a construção de um filme com “aura”
                arcaica, como que saído da própria época mostrada. Nas
                composições das cenas estará presente a paisagem local, e no
                andamento da montagem a calmaria bucólica. A ideia parte do
                interesse profundo pela cultura rural que está em declínio, e da
                qual nossa literatura, nosso cinema e artes tem se esquecido,
                (salvo exceções). Serão retratadas manifestações culturais dessa
                época e região, como a Folia de Reis e a Catira, e mostrados
                costumes domésticos, vestimenta, música, dança, festas
                tradicionais, e a linguagem oral, (com termos, expressões e
                estruturas peculiares). Uma das referências usadas na construção
                dos diálogos foi o livro “Jacú Rabudo” de Hein Leonard Bowles,
                que registra a linguagem oral nos Campos Gerais. Posicionamento
                da câmera, enquadramentos e movimentos terão a naturalidade de
                um olhar próximo, com uso de lentes normais, iluminação e
                movimentos igualmente naturais. Na interpretação, haverá o
                cuidado de evitar sotaques falsos ou exagerados. Buscamos
                narrativa de fácil assimilação por parte do público comum,
                especialmente o do interior. Alguns paralelos desta história
                poderiam ser estabelecidos com a literatura de Guimarães Rosa e
                com tragédias de Sheakespeare em especial Hamlet.
              </S.TextoA>

              <S.TextoC>
                <strong>Direção:</strong> Pedro Merege
              </S.TextoC>
            </S.TextoAContiner>
          </S.ContainerRightA>
        </S.ContainerSubA>
      </S.Body>
      <S.BodyB>
        <S.TitleB>Pedro Merege</S.TitleB>
        <S.TextB>
          Diretor, Montador, Diretor de Fotografia e Roteirista. Com 44 anos de
          experiência na área audiovisual e formação em Engenharia Cartográfica,
          cinema e pós-produção.
          <br />
          <br />
          <strong>Experiência:</strong>
          <br />
          • Atuou na Cinemateca do Museu Guido Viaro (1979–1981).
          <br />
          • Engenheiro Cartógrafo e Coordenador de Projetos em empresas como
          Aerodata S.A. e Esteio S.A. (1982–1996).
          <br />
          • Instrutor e professor em instituições como Editora Sagres, Datum
          Ltda., UFPR e FAP.
          <br />
          • Instrutor de oficinas de cinema (Festival Curta 8, Cinemateca de
          Curitiba). Atuação no Cinema:
          <br />
          • Diretor, montador e roteirista de curtas, telefilmes e longas
          documentais e de ficção.
          <br />
          • Experiência com softwares de edição (Adobe Premiere, Shotcut,
          DaVinci Resolve) e roteiro (Celtx, Trelby).
          <br />
          <br />
          <strong>Premiações:</strong>
          <br />
          • Recebeu prêmios em festivais nacionais e internacionais (Gramado,
          Recife, Rio, Maringá, Lapa, entre outros).
          <br />• Obras premiadas incluem Mistérios, Está nas Escrituras,
          Esmarteza e outros curtas exibidos em diversos festivais.
        </S.TextB>
      </S.BodyB>
    </S.MainContainer>
  );
};

export default FilmeMataramZacarias;
